import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate();

  // Optional: Auto-redirect after 5 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/');
    }, 5000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 to-black flex flex-col items-center justify-center p-6 text-center">
      <div className="max-w-md mx-auto">
        {/* Animated 404 Text */}
        <div className="text-[120px] font-bold text-transparent bg-clip-text bg-gradient-to-r from-red-500 to-orange-500 mb-4 animate-pulse">
          404
        </div>
        
        <h1 className="text-3xl md:text-4xl font-bold text-white mb-6">
          Oops! Page Not Found
        </h1>
        
        <p className="text-xl text-gray-300 mb-8">
          The page you're looking for doesn't exist or has been moved.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/"
            className="px-8 py-3 bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-600 hover:to-blue-700 rounded-lg font-medium text-white transition-all transform hover:scale-105"
          >
            Go to Homepage
          </Link>
          
          <button 
            onClick={() => navigate(-1)}
            className="px-8 py-3 border border-gray-600 hover:bg-gray-800 rounded-lg font-medium text-white transition-all"
          >
            Go Back
          </button>
        </div>
        
        {/* Countdown for auto-redirect (optional) */}
        <p className="text-gray-500 mt-8 text-sm">
          You'll be automatically redirected to homepage in 5 seconds...
        </p>
      </div>
    </div>
  );
};

export default NotFound;